import React, { useState } from 'react';

/**
 * Remplaçant direct de <img> pour alléger le dashboard.
 *
 * - loading="lazy" + decoding="async" : les images hors écran (avatars des longues
 *   tables) ne se téléchargent qu'au défilement, pas toutes à l'ouverture.
 * - `thumb` : utilise la miniature backend quand elle existe (ex: logo_thumb),
 *   avec repli automatique sur l'image pleine.
 * - Fondu à l'apparition + fond placeholder neutre, et masquage propre si l'image
 *   casse (pas d'icône « image brisée »).
 *
 * API identique à <img> : passe `className`, `style`, `alt`, `onClick`, etc.
 */
export default function Img({ src, thumb, alt = '', style, className, onLoad, onError, ...rest }) {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  const realSrc = thumb || src;

  const merged = {
    backgroundColor: '#eef2f6',
    ...style,
    opacity: loaded && !failed ? (style?.opacity ?? 1) : 0,
    transition: 'opacity .25s ease',
  };

  return (
    <img
      {...rest}
      src={realSrc || undefined}
      alt={alt}
      className={className}
      loading="lazy"
      decoding="async"
      style={merged}
      onLoad={(e) => { setLoaded(true); onLoad && onLoad(e); }}
      onError={(e) => { setFailed(true); onError && onError(e); }}
    />
  );
}
